<template>
  <line-chart style="position: relative; height:220px" :data="this.getLineChartData"
              :options="this.lineChartOptions" v-if="this.getLineChartData"></line-chart>
</template>

<script>
  import moment from "moment";
  import LineChart from "../Wrappers/lineChart";

  let width, height, gradient;

  const gradientColors = ['red', 'darkorange', 'green'];
  const labels = ['Minor', 'Average', 'Hot'];

  export default {
    name: "trendLine",
    components: {LineChart},
    props: ['profile', 'companyAvg', 'gradientColors', 'labels'],
    data() {
      return {
        // lineChartData: {},
        lineChartOptions: {
          radius: 0,
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: 'top'
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
            }],
            yAxes: [
            // {
            //   id: 'B',
            //   type: 'category',
            //   labels: ticks,
            //   gridLines: {
            //     display: false
            //   }
            // },
            {
              id: 'A',
              position: 'right',
              gridLines: {
                display: false
              },
              ticks: {
                suggestedMax: 3,
                suggestedMin: 0
              },
              display: false
            }, {
              id: 'C',
              type: 'category',
              position: 'left',
              gridLines: {
                display: false
              },
              labels: this.labels ? this.labels : labels,
              display: true
            }]
          },
        }
      }
    },
    // methods: {
    //   composeLineChartData() {
    //     const labels = this.profile.history.map(e => e.scrapedDate).reverse().map(e => moment(e).format('DD-MMM')).slice(1);
    //     const datasets = [
    //       {
    //         label: 'Weekly engagement',
    //         lineTension: 0.4,
    //         fill: false,
    //         backgroundColor: '#c8841b',
    //         borderColor: '#ffa82d',
    //         yAxisID: 'B',
    //         data: this.profile.edges.market.engagementWeightsLabels.map(e => e.label).reverse()
    //       },
    //       {
    //         label: 'Company average',
    //         lineTension: 0.4,
    //         fill: false,
    //         backgroundColor: '#c4c7fc',
    //         borderColor: '#9c9cd1',
    //         yAxisID: 'A',
    //         data: this.avg.map(e => Math.round(e * 10) / 10)
    //       }
    //       // {
    //       //   label: 'Active sections',
    //       //   lineTension: 0.4,
    //       //   fill: false,
    //       //   backgroundColor: '#306883',
    //       //   borderColor: '#076483',
    //       //   data: this.profile.edges.market.sectionsWithContent.map(e => e.activeSections).reverse()
    //       // },
    //       // {
    //       //   label: 'Weekly risk',
    //       //   lineTension: 0.4,
    //       //   fill: false,
    //       //   backgroundColor: '#c8841b',
    //       //   borderColor: '#ffa82d',
    //       //   yAxisID: 'B',
    //       //   data: this.profile.edges.market.riskWeights.map(e => e.total).reverse()
    //       // },
    //     ];
    //
    //     return {labels, datasets};
    //   }
    // },
    // mounted() {
    //   this.lineChartData = this.composeLineChartData();
    // },
    methods: {
      getGradient(ctx, chartArea){
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (gradient === null || width !== chartWidth || height !== chartHeight) {
          // Create the gradient because this is either the first render
          // or the size of the chart has changed
          width = chartWidth;
          height = chartHeight;
          gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, this.defaultGradientColors()[0]);
          gradient.addColorStop(0.5, this.defaultGradientColors()[1]);
          gradient.addColorStop(1, this.defaultGradientColors()[2]);
        }

        return gradient;
      },
      defaultGradientColors(){
        return this.gradientColors ? this.gradientColors : gradientColors;
      },
      defaultLabels() {
        return this.labels ? this.labels : labels;
      }
    },
    computed: {
      getLineChartData() {
        let datasets = [];
        let labels = [];
        if (this.profile) {
          labels = this.profile.history.map(e => e.scrapedDate).sort((a,b) => b-a).map(e => moment(e).format('DD-MMM')).reverse();
          // datasets.push({
          //   label: 'Old weekly engagement',
          //   lineTension: 0.4,
          //   fill: false,
          //   backgroundColor: '#c8841b',
          //   borderColor: '#ffa82d',
          //   yAxisID: 'B',
          //   data: [0, ...this.profile.edges.market.engagementWeightsLabels.map(e => e.label).reverse()]
          // });
          // if (this.avg) {
          //   datasets.push({
          //     label: 'Old company average',
          //     lineTension: 0.4,
          //     fill: false,
          //     backgroundColor: '#c4c7fc',
          //     borderColor: '#9c9cd1',
          //     yAxisID: 'A',
          //     data: this.avg.map(e => Math.round(e * 10) / 10)
          //   })
          // }
          if (this.companyAvg) {
            datasets.push({
              label: 'Company average',
              lineTension: 0.4,
              pointRadius: 0,
              fill: false,
              backgroundColor: '#c4c7fc',
              borderColor: '#9c9cd1',
              yAxisID: 'A',
              data: this.companyAvg.map(e => Math.round((2 - e.averageActivity)* 100) / 100).reverse()
            })
          }
          datasets.push({
            label: 'Activity',
            lineTension: 0.4,
            pointRadius: 0,
            borderColor: (context) => {
              const chart = context.chart;
              const {ctx, chartArea} = chart;

              if (!chartArea) {
                // This case happens on initial chart load
                return null;
              }
              return this.getGradient(ctx, chartArea);
            },
            fill: false,
            // backgroundColor: 'green',
            // borderColor: 'green',
            yAxisID: 'C',
            data: [
              ...this.profile.edges.engagement.history
                .sort((a,b) => b.scrapedDate - a.scrapedDate)
                .map(e => e.activity ? this.defaultLabels()[e.activity.value] : NaN)
                .reverse()
            ]
          })
        }
        return {labels, datasets};
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/trendLine.vue